import { useSelector } from "react-redux";

import { usePlayerControlsActions } from "store/PlayerControlsSlice";
import { DATA_VOLUME } from "utils/localStorage";

const usePlayerControls = (ref) => {
  const { setPauseVideo, setVolume: _setVolume } = usePlayerControlsActions();
  const { pauseVideo, volume } = useSelector((state) => state.PlayerControlsSlice);

  const refVolume = () => ref?.current?.volume;

  const init = () => {
    if (refVolume() != null && volume != null) {
      const videoPlayer = ref.current;
      if (videoPlayer?.volume) {
        videoPlayer.volume = volume;
      }
    }
  };

  const setVolume = () => {
    const refTemp = refVolume();
    _setVolume(refTemp);
    sessionStorage.setItem(DATA_VOLUME, refTemp || volume);
  };

  return {
    setPauseVideo,
    pauseVideo,
    setVolume,
    volume,
    init,
  };
};

export default usePlayerControls;
